function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
import PropTypes from "prop-types";
import { constants } from "../../styles";
import { CardComponent } from "./style";

var Card = function Card(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  return React.createElement(
    CardComponent,
    props,
    children
  );
};

var _constants$sizes = constants.sizes,
    NONE = _constants$sizes.NONE,
    XXS = _constants$sizes.XXS,
    XS = _constants$sizes.XS,
    SM = _constants$sizes.SM,
    MD = _constants$sizes.MD,
    LG = _constants$sizes.LG,
    XL = _constants$sizes.XL,
    XXL = _constants$sizes.XXL;
var _constants$colors = constants.colors,
    SUCCESS = _constants$colors.SUCCESS,
    WARNING = _constants$colors.WARNING,
    DANGER = _constants$colors.DANGER,
    GRAY = _constants$colors.GRAY,
    PRIMARY = _constants$colors.PRIMARY;


Card.propTypes = {
  spacing: PropTypes.oneOf([NONE, XXS, XS, SM, MD, LG, XL, XXL]),
  status: PropTypes.oneOf([SUCCESS, WARNING, DANGER, GRAY, PRIMARY, null]),
  shadow: PropTypes.oneOf([XS, SM, LG]),
  background: PropTypes.oneOf([SUCCESS, WARNING, DANGER, GRAY, PRIMARY, null]),
  children: PropTypes.node.isRequired,
  border: PropTypes.bool,
  plain: PropTypes.bool
};

Card.defaultProps = {
  spacing: MD,
  status: null,
  shadow: SM,
  border: false,
  background: null,
  plain: false
};

export default Card;